<template>
  <section class="card">
    <div class="card-body">
      <div>
        <a-card title="Outlet List">
          <a href="#" slot="extra"><a-button  type="primary"  @click="showDrawer"><a-icon type="plus" />Create Outlet</a-button></a>
        </a-card>
        <div :class="$style.overallData">
          <ul :class="$style.overallDataList">
            <li :class="$style.overallDataItem">
              <a href="javascript: void(0);">
                Outlet<br>
                {{this.total}}
              </a>
            </li>
            <li :class="$style.overallDataItem">
              <a href="javascript: void(0);">
                Transaction <br>
                {{projectData.branches}}
              </a>
            </li>
            <li :class="$style.overallDataItem">
              <a href="javascript: void(0);">
                Settlement<br>
                {{projectData.releases}}
              </a>
            </li>
            <li :class="$style.overallDataItem">
              <a href="javascript: void(0);">
                Pending KYC <br>
                {{projectData.contributors}}
              </a>
            </li>
          </ul>
        </div>
        <div class="table-responsive">
          <a-table :columns="columns"
                   :dataSource="data"
                   :pagination="pagination"
                   :loading="loading"
                   @change="handleTableChange"
                   :class="$style.table"
          >
            <div
          slot="filterDropdown"
          slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
          class="custom-filter-dropdown"
        >
          <a-input
            v-ant-ref="c => searchInput = c"
            :placeholder="`Search ${column.dataIndex}`"
            :value="selectedKeys[0]"
            @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
            @pressEnter="() => handleSearch(selectedKeys, confirm)"
            style="width: 188px; margin-bottom: 8px; display: block;"
          />
          <a-button
            type="primary"
            @click="() => handleSearch(selectedKeys, confirm)"
            icon="search"
            size="small"
            style="width: 90px; margin-right: 8px"
          >Search</a-button>
          <a-button @click="() => handleReset(clearFilters)" size="small" style="width: 90px">Reset</a-button>
        </div>
            <a-icon
                    slot="filterIcon"
                    slot-scope="filtered"
                    type="search"
                    :style="{ color: filtered ? '#108ee9' : undefined }"
            />
            <template slot="customRender" slot-scope="text">
          <span v-if="searchText">
            <template
              v-for="(fragment, i) in text.toString().split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i'))"
            >
              <mark
                v-if="fragment.toLowerCase() === searchText.toLowerCase()"
                :key="i"
                class="highlight"
              >{{fragment}}</mark>
              <template v-else>{{fragment}}</template>
            </template>
          </span>
          <template v-else>{{text}}</template>
        </template>
        <a
          slot="id"
          slot-scope="text"
          href="javascript: void(0);"
          class="utils__link--underlined"
        >#{{text}}</a>
            <span slot="customRender" slot-scope="value">{{ value.mobile_number }}<br> {{ value.number }}</span>
            <template slot="name" slot-scope="name">
              {{name.toUpperCase()}}
            </template>
            <span slot="kyc"  slot-scope="value">
              <a-icon v-if="value == 1" type="check-circle" theme="twoTone" two-tone-color="#52c41a" />
              <a-icon v-if="value == 0" type="close-circle" theme="twoTone" two-tone-color="#eb2f96" />
            </span>
            <span slot="action" slot-scope="value">
          <a-button icon="edit" @click="showModal(value)" class="mr-1" size="small">View</a-button>
        </span>
          </a-table>
        </div>
      </div>
    </div>
    <a-drawer
      title="Create a new Outlet"
      :width="720"
      @close="onClose"
      :visible="visible"
      :wrapStyle="{height: 'calc(100% - 108px)',overflow: 'auto',paddingBottom: '108px'}"
    >
      <a-form :form="form" @submit="handleSubmit" layout="vertical" hideRequiredMark>
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-item
                    :validate-status="errors.first_name ? 'error' : '' "
                    :help="errors.first_name"
                    label="First Name">
              <a-input
                v-decorator="['first_name']"
                placeholder="Please enter first name"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :validate-status="errors.last_name ? 'error' : '' "
                         :help="errors.last_name" label="Last Name">
              <a-input
                v-decorator="['last_name']"
                style="width: 100%"
                placeholder="please enter last name"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-item :validate-status="errors.mobile_number ? 'error' : '' "
                         :help="errors.mobile_number" label="Mobile">
              <a-input
                v-decorator="['mobile_number']"
                placeholder="Please enter mobile number"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :validate-status="errors.email ? 'error' : '' "
                         :help="errors.email" label="Email">
              <a-input
                v-decorator="['email']"
                style="width: 100%"
                placeholder="please enter email"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="8">
            <a-form-item :validate-status="errors.pan_number ? 'error' : '' "
                         :help="errors.pan_number" label="PAN Number">
              <a-input
                v-decorator="['pan_number']"
                placeholder="Please enter PAN Number"
              />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :validate-status="errors.aadhar_number ? 'error' : '' "
                         :help="errors.aadhar_number" label="KYC Number">
              <a-input
                v-decorator="['aadhar_number']"
                style="width: 100%"
                placeholder="please enter Aadhar Number"
              />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :validate-status="errors.company ? 'error' : '' "
                         :help="errors.company" label="Shop Name/ Company">
              <a-input
                      v-decorator="['company']"
                      style="width: 100%"
                      placeholder="please enter Shop Name"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="6">
            <a-form-item :validate-status="errors.pin_code ? 'error' : '' "
                         :help="errors.pin_code" label="PIN Code">
              <a-input
                v-decorator="['pin_code']"
                placeholder="Please enter PIN Code"
              />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :validate-status="errors.circle_id ? 'error' : '' "
                         :help="errors.circle_id" label="State">
              <a-select
                      placeholder="Inserted are removed"
                      :value="circle_id"
                      style="width: 100%"
                      @change="handleChange"
              >
                <a-select-option v-for="item in selectedItems" :key="item.id" :value="item.id">
                  {{ item.circle_name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :validate-status="errors.city ? 'error' : '' "
                         :help="errors.city" label="City">
              <a-input
                      v-decorator="['city']"
                      placeholder="Please enter City Name"
              />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :validate-status="errors.district ? 'error' : '' "
                         :help="errors.district" label="District">
              <a-input
                      v-decorator="['district']"
                      placeholder="Please enter District"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-item :validate-status="errors.bank_account_number ? 'error' : '' "
                         :help="errors.bank_account_number" label="Bank Account Number">
              <a-input
                      v-decorator="['bank_account_number']"
                      placeholder="Please enter Bank Account Number"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :validate-status="errors.ifsc ? 'error' : '' "
                         :help="errors.ifsc" label="IFSC">
              <a-input
                      v-decorator="['ifsc']"
                      style="width: 100%"
                      placeholder="please enter IFSC"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="24">
            <a-form-item :validate-status="errors.address ? 'error' : '' "
                         :help="errors.address" label="Address">
              <a-textarea
                v-decorator="['address']"
                :rows="4"
                placeholder="please enter Address"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <div class="form-actions">
          <a-button
            :style="{marginRight: '8px'}"
            @click="onClose"
          >
            Cancel
          </a-button>
          <a-button htmlType="submit" type="primary">Submit</a-button>
        </div>
      </a-form>
    </a-drawer>
    <a-modal
      :visible="visibleModal"
      @ok="handleOk"
      :width=820
      :footer="null"
      :confirmLoading="confirmLoading"
      @cancel="handleCancel"
    >
      <a-tabs
              @tabClick="getService"
              defaultActiveKey="1">
        <a-tab-pane key="1">
      <span slot="tab">
        <a-icon type="user" />
        Profile
      </span>
          <a-form :form="form" @submit="handleSubmitupdate" layout="vertical" hideRequiredMark>
            <a-row :gutter="16">
              <a-col :span="12">
                <a-form-item label="First Name">
                  <a-input
                    v-decorator="['first_name', {
                      initialValue: this.outletdata.first_name,
                      rules: [{ required: true, message: 'Please enter first name' }]
                  }]"
                    placeholder="Please enter first name"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="Last Name">
                  <a-input
                    v-decorator="['last_name', {
                      initialValue: this.outletdata.last_name,
                      rules: [{ required: true, message: 'please enter last name' }]
                }]"
                    style="width: 100%"
                    placeholder="please enter last name"
                  />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="16">
              <a-col :span="12">
                <a-form-item label="Mobile">
                  <a-input
                    v-decorator="['mobile_number', {
                      initialValue: this.outletdata.mobile_number,
                      rules: [{ required: true, message: 'Please enter mobile number' }]
                }]"
                    placeholder="Please enter mobile number"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="Email">
                  <a-input
                    v-decorator="['email', {
                      initialValue: this.outletdata.email,
                      rules: [{ required: true, message: 'please enter email' }]
                    }]"
                    style="width: 100%"
                    placeholder="please enter email"
                  />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="16">
              <a-col :span="8">
                <a-form-item label="PAN Number">
                  <a-input
                    v-decorator="['pan_number', {
                      initialValue: this.outletdata.pan_number,
                      rules: [{ required: true, message: 'Please enter PAN number' }]
                    }]"
                    placeholder="Please enter PAN Number"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item label="KYC Number">
                  <a-input
                    v-decorator="['aadhar_number', {
                      initialValue: this.outletdata.aadhar_number,
                      rules: [{ required: true, message: 'please enter Aadhar number' }]
                }]"
                    style="width: 100%"
                    placeholder="please enter KYC Number"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item label="Shop Name/ Company">
                  <a-input
                          v-decorator="['company', {
                      initialValue: this.outletdata.company,
                      rules: [{ required: true, message: 'please enter Shop Name' }]
                    }]"
                          style="width: 100%"
                          placeholder="please enter Shop Name"
                  />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="16">
              <a-col :span="6">
                <a-form-item label="PIN Code">
                  <a-input
                    v-decorator="['pin_code', {
                      initialValue: this.outletdata.pin_code,
                      rules: [{ required: true, message: 'Please enter PIN code' }]
                    }]"
                    placeholder="Please enter PIN Code"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item :validate-status="errors.circle_id ? 'error' : '' "
                             :help="errors.circle_id" label="State">
                  <a-select
                          placeholder="Inserted are removed"
                          :value="circle_id"
                          style="width: 100%"
                          @change="handleChange"
                  >
                    <a-select-option v-for="item in selectedItems" :key="item.id" :value="item.id">
                      {{ item.circle_name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item :validate-status="errors.city ? 'error' : '' "
                             :help="errors.city" label="City">
                  <a-input
                          v-decorator="['city', {
                      initialValue: this.outletdata.city,
                      rules: [{ required: true, message: 'Please enter City' }]
                    }]"
                          placeholder="Please enter City Name"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item :validate-status="errors.district ? 'error' : '' "
                             :help="errors.district" label="District">
                  <a-input
                          v-decorator="['district', {
                      initialValue: this.outletdata.district,
                      rules: [{ required: true, message: 'Please enter district' }]
                    }]"
                          placeholder="Please enter District"
                  />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="16">
              <a-col :span="8">
                <a-form-item label="Bank Account Number">
                  <a-input
                          v-decorator="['bank_account_number', {
                      initialValue: this.outletdata.bank_account_number,
                      rules: [{ required: true, message: 'Please enter Bank Account Number' }]
                    }]"
                          placeholder="Please enter Bank Account Number"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item label="IFSC">
                  <a-input
                          v-decorator="['ifsc', {
                            initialValue: this.outletdata.ifsc,
                            rules: [{ required: true, message: 'please enter IFSC' }]
                          }]"
                          style="width: 100%"
                          placeholder="please enter IFSC"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item label="Remark">
                  <a-input
                          v-decorator="['remark', {
                            initialValue: this.outletdata.remark,
                            rules: [{ required: false, message: 'please enter Remark' }]
                          }]"
                          style="width: 100%"
                          placeholder="please enter Remark"
                  />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="16">
              <a-col :span="24">
                <a-form-item label="Address">
                  <a-textarea
                    v-decorator="['address', {
                      initialValue: this.outletdata.address,
                      rules: [{ required: true, message: 'Please enter Address' }]
                    }]"
                    :rows="4"
                    placeholder="please enter Address"
                  />
                </a-form-item>
              </a-col>
            </a-row>
            <div class="form-actions">
              <a-button
                :style="{marginRight: '8px'}"
                @click="handleCancel"
              >
                Cancel
              </a-button>
              <a-button htmlType="submit" type="primary">Submit</a-button>
            </div>
          </a-form>
        </a-tab-pane>
        <a-tab-pane key="2">
      <span slot="tab">
        <a-icon type="wallet" />
         Bank Account
      </span>
          <a-card title="Account Detail">
            <a href="#" slot="extra">History</a>
            <a-table :columns="columnsbank" :dataSource="databank" bordered>
              <span slot="name" slot-scope="value">{{ value }}<br> {{ value }}</span>
            </a-table>
          </a-card>
        </a-tab-pane>
        <a-tab-pane key="3">
      <span slot="tab">
        <a-icon type="book" />
         Services
      </span>
          <a-card>
            <div class="table-responsive">
              <table :class="$style.nav" class="table table-hover text-nowrap">
                <thead>
                <tr>
                  <th>ID</th>
                  <th>Service</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in dataservice" :key="index">
                  <td>
                    {{item.id}}
                  </td>
                  <td>
                    <a href="javascript: void(0);">{{item.service_name}}</a>
                  </td>
                  <td>
                    <a-switch v-model="item.status" @change='onChange(item.id)'/>
                  </td>
                  <td>
                    <a-button icon="eye" @click="showModalPan(item)" class="mr-1" size="small">View</a-button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <a-modal title="Pancard Agent" v-model="visiblepanCard" @ok="handleOk">
              <a-button @click="activatePanAgent(service_id)">
                 Activate Now
              </a-button>
            </a-modal>
          </a-card>
        </a-tab-pane>
        <a-tab-pane key="4">
      <span slot="tab">
        <a-icon type="user" />
         KYC
      </span>
          Comming Soon
        </a-tab-pane>
        <a-tab-pane key="5">
      <span slot="tab">
        <a-icon type="book" />
         Transaction
      </span>
          Comming Soon
        </a-tab-pane>
      </a-tabs>
    </a-modal>
  </section>
</template>

<script>
import { projectData } from './data.json'
import { apiPath } from '../../../config'
const columns = [{
  title: 'ID',
  dataIndex: 'id',
}, {
  title: 'Name',
  dataIndex: 'name',
  sorter: true,
  width: '20%',
  scopedSlots: { customRender: 'name' },
}, {
  title: 'Mobile Number',
  key: 'mobile_number',
  scopedSlots: {
    filterDropdown: 'filterDropdown',
    filterIcon: 'filterIcon',
    customRender: 'customRender',
  },
  onFilterDropdownVisibleChange: (visible) => {
    if (visible) {
      setTimeout(() => {
        this.searchInput.focus()
      }, 0)
    }
  },
}, {
  title: 'Email',
  dataIndex: 'email',
}, {
  title: 'PAN Number',
  dataIndex: 'pan_number',
}, {
  title: 'Pin Code',
  dataIndex: 'pin_code',
},
{
  title: 'KYC',
  key: 'is_kyc',
  dataIndex: 'is_kyc',
  scopedSlots: { customRender: 'kyc' },
}, {
  title: 'Action',
  key: 'action',
  scopedSlots: { customRender: 'action' },
}]

const columnsbank = [{
  title: 'Name',
  dataIndex: 'name',
  width: '20%',
}, {
  title: 'Account Number',
  dataIndex: 'account_number',
  width: '20%',
}, {
  title: 'IFSC',
  dataIndex: 'ifsc',
}, {
  title: 'Mode',
  dataIndex: 'mode',
}]

const columnsservice = [{
  title: 'Service',
  dataIndex: 'service_name',
}, {
  title: 'Status',
  dataIndex: 'status',
}, {
  title: 'Description',
  dataIndex: 'description',
}, {
  title: 'Action',
  dataIndex: 'mode',
}]

export default {
  data: function () {
    return {
      form: this.$form.createForm(this),
      visible: false,
      visiblepanCard: false,
      projectData,
      columns,
      searchText: '',
      columnsbank,
      circle_id: 'Select State',
      columnsservice,
      outletdata: [],
      data: [],
      databank: [],
      dataservice: [],
      pagination: {},
      loading: true,
      ModalText: 'Content of the modal',
      confirmLoading: false,
      visibleModal: false,
      visibleModaldata: '',
      total: 0,
      service_id: '',
      errors: [],
      selectedItems: [],
    }
  },
  mounted() {
    this.fetch()
    this.fetchCircle()
  },
  methods: {
    getService(val) {
      if (val === '3') {
        this.loading = true
        const axios = require('axios')
        axios.get(apiPath + 'v1/app/userservice')
          .then((data) => {
            this.loading = false
            this.dataservice = data.data.data
          })
      }
    },
    showModal(value) {
      this.visibleModaldata = value
      this.outletdata = value
      this.outlet_id = value.id
      this.circle_id = value.circle_id
      this.databank = [value.bankdetail]
      this.visibleModal = true
      console.log(this.databank)
    },
    showModalPan(value) {
      this.service_id = value
      this.visiblepanCard = true
    },
    handleOk(e) {
      this.ModalText = 'The modal will be closed after two seconds'
      this.confirmLoading = true
      setTimeout(() => {
        this.visibleModal = false
        this.confirmLoading = false
      }, 2000)
    },
    handleCancel(e) {
      console.log('Clicked cancel button')
      this.visibleModal = false
    },
    handleTableChange (pagination, filters, sorter) {
      console.log(pagination)
      const pager = { ...this.pagination }
      pager.current = pagination.current
      this.pagination = pager
      this.fetch({
        results: pagination.pageSize,
        page: pagination.current,
        sortField: sorter.field,
        sortOrder: sorter.order,
        ...filters,
      })
    },
    fetchCircle() {
      const axios = require('axios')
      axios.get(apiPath + 'v1/app/circle')
        .then((data) => {
          this.selectedItems = data.data.data
        })
    },
    fetch (params = {}) {
      console.log('params:', params)
      this.loading = true
      const axios = require('axios')
      axios.get(apiPath + 'v1/outlet?search_val=' + this.searchText + '&page=' + params.page)
        .then((data) => {
          const pagination = { ...this.pagination }
          // Read total count from server
          // pagination.total = data.totalCount;
          pagination.total = data.data.total
          this.loading = false
          this.data = data.data.data
          this.total = data.data.total
          this.pagination = pagination
        })
    },
    handleSubmit (e) {
      e.preventDefault()
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          const axios = require('axios')
          values.circle_id = this.circle_id
          axios.post(apiPath + 'v1/outlet/store', values)
            .then((data) => {
              this.$nprogress.done()
              if (data.data.status === 0) {
                this.$notification['success']({
                  message: data.data.message,
                  description: data.description,
                })
              } else {
                this.$notification['error']({
                  message: data.data.message,
                  description: data.description,
                })
              }
            })
            .catch(error => {
              this.loading = false
              this.errors = error.response.data.errors
            })
        }
      })
    },
    activatePanAgent (value) {
      this.loading = true
      const axios = require('axios')
      let formData = {
        outlet_id: this.outlet_id,
        service_id: value.id,
      }
      axios.post(apiPath + 'v1/pan/create', formData)
        .then((data) => {
          this.loading = false
          this.$nprogress.done()
          this.amount = ''
          if (data.data.status === 0) {
            this.orderdetail = data.data.data
            this.$notification['success']({
              message: data.data.message,
              description: data.description,
            })
            this.fetchUser()
            this.fetch()
          } else {
            this.$notification['error']({
              message: data.data.message,
              description: data.description,
            })
          }
        })
        .catch(error => {
          this.loading = false
          this.errors = error.response.data.errors
          this.$nprogress.done()
          this.$notification['error']({
            message: error.message,
            description: error,
          })
        })
    },
    handleSubmitupdate (e) {
      e.preventDefault()
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          const axios = require('axios')
          values.circle_id = this.circle_id
          values.outlet_id = this.outletdata.id
          axios.post(apiPath + 'v1/outlet/update', values)
            .then((data) => {
              this.$nprogress.done()
              if (data.data.status === 0) {
                this.$notification['success']({
                  message: data.data.message,
                  description: data.description,
                })
              } else {
                this.$notification['error']({
                  message: data.data.message,
                  description: data.description,
                })
              }
            })
            .catch(error => {
              this.loading = false
              this.errors = error.response.data.errors
            })
        }
      })
    },
    handleSearch(selectedKeys, confirm, dataIndex) {
      this.searchText = selectedKeys[0]
      this.searchedColumn = dataIndex
      this.fetch()
    },
    showDrawer() {
      this.visible = true
    },
    onClose() {
      this.visible = false
    },
    onChange(checked) {
      console.log(`a-switch to ${checked}`)
    },
    handleChange(selectedItems) {
      this.circle_id = selectedItems
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
  },
}
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
